import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import PortalShell from "@/components/portal/PortalShell";
import { ErrorState } from "@/components/eds";

// WP2.1B-R2: 404 rendered inside the portal chrome (nav + footer) for
// consistent header/footer treatment across every route. Route-logging
// behaviour and the governed ErrorState are unchanged.
const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <PortalShell>
      <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-eds-bg px-4 py-16">
        <ErrorState
          className="max-w-md"
          title="404: Page not found"
          message="The page you are looking for does not exist or has moved."
          action={
            <Link
              to="/"
              className="inline-flex h-9 items-center rounded-eds-md bg-eds-primary px-4 font-eds-body text-sm font-semibold text-eds-primary-fg hover:bg-eds-emerald-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-eds-ring focus-visible:ring-offset-2 focus-visible:ring-offset-eds-bg"
            >
              Return to Home
            </Link>
          }
        />
      </div>
    </PortalShell>
  );
};

export default NotFound;
